import {
  Autocomplete as MuiAutocomplete,
  Box as MuiBox,
  Button as MuiButton,
  Checkbox as MuiCheckbox,
  Container as MuiContainer,
  Dialog as MuiDialog,
  DialogActions as MuiDialogActions,
  DialogContent as MuiDialogContent,
  DialogTitle as MuiDialogTitle,
  Divider as MuiDivider,
  FormControl as MuiFormControl,
  FormControlLabel as MuiFormControlLabel,
  FormGroup as MuiFormGroup,
  FormHelperText as MuiFormHelperText,
  IconButton as MuiIconButton,
  Input as MuiInput,
  InputAdornment as MuiInputAdornment,
  InputLabel as MuiInputLabel,
  Menu as MuiMenu,
  MenuItem as MuiMenuItem,
  Paper as MuiPaper,
  Radio as MuiRadio,
  RadioGroup as MuiRadioGroup,
  Select as MuiSelect,
  Stack as MuiStack,
  Switch as MuiSwitch,
  Table as MuiTable,
  TableBody as MuiTableBody,
  TableCell as MuiTableCell,
  TableContainer as MuiTableContainer,
  TableHead as MuiTableHead,
  TableRow as MuiTableRow,
  TextField as MuiTextField,
  Tooltip as MuiTooltip,
  Typography as MuiTypography,
} from "@mui/material";

// ✅ Utility to add default props and style without forwardRef
const withDefaults = (Component, defaultProps = {}, defaultStyle = {}) => (props) => {
  const { style, ...rest } = props;
  return (
    <Component
      {...defaultProps}
      {...rest}
      style={{ ...defaultStyle, ...style }}
    />
  );
};

// ✅ Exports (cleaned up)
export const Autocomplete = withDefaults(MuiAutocomplete);
export const Box = withDefaults(MuiBox);
export const Button = withDefaults(MuiButton, {
  variant: "contained",
  disableElevation: true,
}, {
  textTransform: "none",
});
export const Checkbox = withDefaults(MuiCheckbox);
export const Container = withDefaults(MuiContainer);
export const Dialog = withDefaults(MuiDialog);
export const DialogActions = withDefaults(MuiDialogActions);
export const DialogContent = withDefaults(MuiDialogContent);
export const DialogTitle = withDefaults(MuiDialogTitle);
export const Divider = withDefaults(MuiDivider);
export const FormControl = withDefaults(MuiFormControl);
export const FormControlLabel = withDefaults(MuiFormControlLabel);
export const FormGroup = withDefaults(MuiFormGroup);
export const FormHelperText = withDefaults(MuiFormHelperText);
export const IconButton = withDefaults(MuiIconButton);
export const Input = withDefaults(MuiInput);
export const InputAdornment = withDefaults(MuiInputAdornment);
export const InputLabel = withDefaults(MuiInputLabel);
export const Menu = withDefaults(MuiMenu);
export const MenuItem = withDefaults(MuiMenuItem);
export const Paper = withDefaults(MuiPaper);
export const Radio = withDefaults(MuiRadio);
export const RadioGroup = withDefaults(MuiRadioGroup);
export const Select = withDefaults(MuiSelect);
export const Stack = withDefaults(MuiStack);
export const Switch = withDefaults(MuiSwitch);
export const Table = withDefaults(MuiTable);
export const TableBody = withDefaults(MuiTableBody);
export const TableCell = withDefaults(MuiTableCell);
export const TableContainer = withDefaults(MuiTableContainer);
export const TableHead = withDefaults(MuiTableHead);
export const TableRow = withDefaults(MuiTableRow);
export const TextField = withDefaults(MuiTextField, {
  variant: "outlined",
  size: "small",
  fullWidth: true,
});
export const Tooltip = withDefaults(MuiTooltip);
export const Typography = withDefaults(MuiTypography, {}, {
  fontFamily: "'Roboto', sans-serif",
});
